// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModalLine_customerTitle__4BxId","customerLabel":"ConfirmDeleteModalLine_customerLabel__VWJBw","customerBtn":"ConfirmDeleteModalLine_customerBtn__tbYvC"};